"use client"

import AuthForm from "../organisms/AuthForm/auth-form"
import AuthPage from "../templates/Auth/auth-template"
import React from "react"
import { useSearchParams } from "next/navigation"
import useLocaleStore from "@/app/stores/useLocaleStore"

const LoginPage: React.FC = () => {
const locale = useLocaleStore((state) => state.locale)
const searchParams = useSearchParams()
const rawCallback = searchParams.get("callbackUrl")
const callbackUrl = rawCallback ? decodeURIComponent(rawCallback) : undefined

  return (
    <AuthPage>
      <AuthForm
        mode="login"
        heading={locale === "en" ? "Login To Your Account" : "ወደ መለያዎ ይግቡ"}
        buttonText={locale === "en" ? "Log In" : "ግባ"}
        secondaryLinkText={locale === "en" ? "Sign Up" : "መመዝገብ"}
        secondaryLinkHref="/auth/signup"
        secondaryLinkLabel={locale === "en" ? "Don't have an account?" : "መለያ አካውንት የለህም?"}
        callbackUrl={callbackUrl}
      />
    </AuthPage>
  )
}

export default LoginPage
